import { render } from "./Formato2004.vue?vue&type=template&id=70c4fd38&scoped=true"
import script from "./Formato2004.vue?vue&type=script&lang=js"
export * from "./Formato2004.vue?vue&type=script&lang=js"

import "./Formato2004.vue?vue&type=style&index=0&id=70c4fd38&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c4fd38"]])

export default __exports__